import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProgressSpinnerState } from './progress-spinner';
import { ProgressSpinnerService } from './progress-spinner.service';

@Component({
    selector: 'angular-progress-spinner',
    templateUrl: 'progress-spinner.component.html',
    styleUrls: ['progress-spinner.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProgressSpinnerComponent implements OnInit {

    show = false;
    private subscription: Subscription;

    constructor(
        private cdr: ChangeDetectorRef,
        private progressSpinnerService: ProgressSpinnerService
    ) {
    }

    ngOnInit() {
        this.subscription = this.progressSpinnerService.progressSpinnerState
            .subscribe((state: ProgressSpinnerState) => {
                this.show = state.show;
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}